// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Account_spinner__1Hfqn","noAccess":"Account_noAccess__8Ze9G","welcome":"Account_welcome__Kohpl"};